import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '@/analytics/posthog';

/**
 * Component to track route changes with PostHog
 * This ensures accurate pageview tracking for SPAs
 */
export const PosthogRouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const fullPath = location.pathname + location.search;
    
    // Track pageview on route change
    trackPageview(fullPath);
  }, [location]);

  return null;
};